import { generateButtons } from '../../../../helpers/generic-js/menus/index.js'
import { updateView } from './update-view.js'

export const menuOptions = {}

export function showMenu () {
  menuOptions.optionGrouping = generateButtons({
    containerId: 'optionGrouping',
    groupLabel: 'Accounts grouped by',
    buttonOptions: [
      {
        label: 'Code',
        value: 'code'
      },
      {
        label: 'Name',
        value: 'name'
      }
    ],
    selected: 'name',
    onChange: function () {
      updateView()
    }
  })

  menuOptions.outputShow = generateButtons({
    containerId: 'outputShow',
    groupLabel: 'Show',
    buttonOptions: [
      {
        label: 'Code',
        value: 'code'
      },
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Type',
        value: 'type'
      },
      {
        label: 'Associated Entity',
        value: 'associatedEntity'
      }
    ],
    selected: 'associatedEntity',
    onChange: function () {
      updateView()
    }
  })

  menuOptions.filterStatement = generateButtons({
    containerId: 'filterStatement',
    groupLabel: 'Financial Statement',
    buttonOptions: [
      {
        label: 'Balance Sheet',
        value: 'bs'
      },
      {
        label: 'Profit & Loss',
        value: 'pnl'
      },
      {
        label: 'Both',
        value: 'both'
      }
    ],
    selected: 'pnl',
    onChange: function () {
      updateView()
    }
  })

  menuOptions.filterGroupAccounts = generateButtons({
    containerId: 'filterGroupAccounts',
    groupLabel: 'Group Accounts',
    buttonOptions: [
      {
        label: 'All Accounts',
        value: 'all'
      },
      {
        label: 'Intercompany Accounts',
        value: 'intercompany'
      },
      {
        label: 'Not Intercompany',
        value: 'notIntercompany'
      }
    ],
    selected: 'all',
    onChange: function () {
      updateView()
    }
  })
}
